(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-plus10-tsui"]) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-section-type="plus10"]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var buttons = root.querySelectorAll('[data-plus10-filter]');
      var cards = root.querySelectorAll('[data-plus10-tags]');
      var empty = root.querySelector('[data-plus10-filter-empty]');
      if (!buttons.length || !cards.length) return;

      function apply(filter) {
        var visible = 0;
        cards.forEach(function (card) {
          var tags = (card.getAttribute('data-plus10-tags') || '').split(',');
          var show = filter === 'all' || tags.indexOf(filter) !== -1;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var filter = button.getAttribute('data-plus10-filter');
          buttons.forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          apply(filter);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom-tsui"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShowroomStickyCta() {
      var stickies = document.querySelectorAll("[data-showroom-sticky]");
      if (!stickies.length || !("IntersectionObserver" in window)) return;

      stickies.forEach(function (sticky) {
        if (sticky.dataset.bound === "true") return;
        sticky.dataset.bound = "true";

        var root = sticky.closest(".Showroom");
        if (!root) return;
        var inlineCta = root.querySelector(".Showroom__Cta");
        if (!inlineCta) return;

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              sticky.classList.toggle("is-hidden", entry.isIntersecting);
            });
          },
          { threshold: 0.4 }
        );

        observer.observe(inlineCta);
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initShowroomStickyCta);
    } else {
      initShowroomStickyCta();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
